var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7265 3.79535C12.4028 4.11912 11.9555 4.31938 11.4614 4.31938H3.11209C2.95392 4.31938 2.80223 4.38221 2.69038 4.49405C2.57854 4.6059 2.51571 4.75759 2.51571 4.91576V21.6145C2.51571 21.7726 2.57854 21.9243 2.69038 22.0362C2.80222 22.148 2.95392 22.2109 3.11209 22.2109H19.8108C19.9689 22.2109 20.1206 22.148 20.2325 22.0362C20.3443 21.9243 20.4071 21.7726 20.4071 21.6145V13.2651C20.4071 12.7711 20.6074 12.3238 20.9312 12L22.1963 13.2651V21.6145C22.1963 22.2472 21.945 22.8539 21.4976 23.3013C21.0502 23.7487 20.4434 24 19.8108 24H3.11209C2.47941 24 1.87264 23.7487 1.42527 23.3013C0.977894 22.8539 0.726562 22.2472 0.726562 21.6145V4.91576C0.726562 4.28308 0.977894 3.67631 1.42527 3.22893C1.87264 2.78156 2.47941 2.53023 3.11209 2.53023H11.4614L12.7265 3.79535Z",
    fill: "#212737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1963 1.78915C21.9998 1.78915 21.8113 1.86723 21.6723 2.00621L10.6915 12.9871L10.3421 14.3845L11.7395 14.0351L22.7204 3.05427C22.8593 2.91528 22.9374 2.72679 22.9374 2.53024C22.9374 2.33369 22.8593 2.14519 22.7204 2.00621C22.5814 1.86723 22.3929 1.78915 22.1963 1.78915ZM12.6542 15.6507L23.9855 4.31938C24.46 3.84487 24.7266 3.2013 24.7266 2.53024C24.7266 1.85918 24.46 1.2156 23.9855 0.741089C23.511 0.266578 22.8674 0 22.1963 0C21.5253 0 20.8817 0.266578 20.4072 0.741089L9.07594 12.0724L7.88318 16.8434L12.6542 15.6507Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2fc90d0175264247f0164b5f70ebb280.svg";
export { ForwardRef as ReactComponent };